/**
 * The `/auth/login` `redirect` value after a session ends; `undefined` when there is nowhere to return.
 *
 * - Takes an origin-less `ParsedLocation.href`, so it satisfies the login route's search schema.
 * - Excludes the `/auth` subtree by path (`/auth?next=x` too): returning there after sign-in loops.
 */
export const returnTo = (href: string): string | undefined => {
  const path = href.split(/[?#]/)[0];
  return path === '/auth' || href.startsWith('/auth/') ? undefined : href;
};
